export const CALENDAR_URLS = {
  consultation: "https://cal.com/niumora-ai/project-consultation",
  bootcamp: "https://cal.com/niumora-ai/ai-bootcamp",
  "expert-session": "https://cal.com/niumora-ai/expert-session",
} as const;
